// modules
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IconModule } from '../icon/icon.module';

// imports
import { Number } from './number.component';

@NgModule({
  declarations: [
    Number
  ],
  exports: [
    Number
  ],
  imports: [
    FormsModule,
    CommonModule,
    IconModule,
  ]
})
export class NumberModule { }

export { Number };
